//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FeedbackBlockPopup',

  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  emits: [
    'close',
  ],

  data: function () {
    return {
      swiperOptions: {
        speed: 1000,
        spaceBetween: 24,
        centerSlides: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        pagination: {
          // el: ".swiper-pagination",
          el: ".feedback-block__swiper-pagination",
          clickable: true,
          bulletElement: "div",
          dynamicMainBullets: 0
        },
        navigation: {
          prevEl: '.swiper-popup__button-navigation--prev',
          nextEl: '.swiper-popup__button-navigation--next'
        },
      },
      isShowPlayButton: true,
    }
  },

  computed: {
    imagesArray: function () {
      return this.item.images || []
    },
  },

  mounted: function () {
    document.body.style.overflow = "hidden";
  },
  destroyed: function () {
    document.body.style.overflow = "";
  },

  methods: {
    closeBigCard: function () {
      this.$emit('close');
    },
    handleVideo: function () {
      if (this.$refs[`refPopupVideo-${this.item.video}`].paused) {
        this.$refs[`refPopupVideo-${this.item.video}`].play()
        this.isShowPlayButton = false;
      } else {
        this.$refs[`refPopupVideo-${this.item.video}`].pause()
        this.isShowPlayButton = true;
      }
    },
  },
}
